// extracted by mini-css-extract-plugin
export var defaultFeaturedMediaImage = "DefaultFeaturedMediaImage-module--default-featured-media-image--8WYz9";
export var fullHeight = "DefaultFeaturedMediaImage-module--full-height--AVQiN";
export var image = "DefaultFeaturedMediaImage-module--image--SxX-x";